'use strict'
var process = require('./process')
try {
  module.exports = setImmediate
} catch (ex) {
  module.exports = process.nextTick
}



//////////////////
// WEBPACK FOOTER
// ./~/fsevents/~/gauge/set-immediate.js
// module id = 2869
// module chunks = 0